import { render, staticRenderFns } from "./template.vue?vue&type=template&id=0f6e3f9c&scoped=true"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=0f6e3f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6e3f9c",
  null
  
)

export default component.exports